import { api } from "@/api/client";
import type { PageInfo } from "@/types/api";

/** Секция настроек ЭТОЙ инсталляции: ключ (маршрут и значок — во фронтовом
 *  реестре `src/nav.ts`) и заголовок для меню. Порядок списка — порядок в
 *  меню, его задаёт сервер. */
export interface SettingsSection {
  key: string;
  title: string;
}

/** Конфигурация ИНСТАЛЛЯЦИИ (не пользователя): какие разделы здесь вообще есть.
 *
 * Фронт собирается один на все инсталляции, поэтому «какая это компания и что
 * у неё подключено» приходит в рантайме. Эндпоинт публичный — экран входа
 * рисует заголовок до авторизации. */
export interface PortalConfig {
  profile: string;
  title: string;
  version: string;
  pages: PageInfo[];
  /** Сервис Честного знака есть в этой инсталляции — от него зависит набор
   *  системных настроек, а не набор разделов. */
  honest_sign: boolean;
  /** Есть ли ПТМО. Без него контрагент-владелец, контрагент-получатель и
   *  договор передачи — реквизиты документа, который не будет создан. */
  ptmo: boolean;
  /** Префикс строки пропуска (`WHB1:`). Приходит с сервера, а не зашит здесь:
   *  по нему экран входа опознаёт пропуск, отсканированный ТСД, и разъезд
   *  двух копий константы сломал бы вход молча. */
  badge_prefix: string;
  /** Секции настроек этой инсталляции в порядке меню
   *  (`backend/src/wh_helper/settings_sections.py`). */
  settings_sections: SettingsSection[];
  /** Вход через SSO (Zitadel) включён в этой инсталляции — кнопка на экране
   *  входа и справочник баз 1С в администрировании. */
  sso_enabled: boolean;
}

export async function getPortalConfig(): Promise<PortalConfig> {
  const { data } = await api.get<PortalConfig>("/config");
  return data;
}
